import { Component, OnInit, ViewChild, Renderer2, OnDestroy } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { MatDialog } from '@angular/material';
import { MostrarComponent } from '../mostrar/mostrar.component';
import { MatSidenav } from '@angular/material';

import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { switchMap } from 'rxjs/operators';
import 'rxjs/add/observable/combineLatest';
import * as firebase from 'firebase/app';
import { Router, NavigationEnd } from '@angular/router';

import { ComentariosService } from '../../core/comentarios.service';

import { User } from '../../interfaces/user';

import { CATEGORIAS } from '../../interfaces/categorias';

import { PublicacionService } from '../../core/publicacion.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { EventosService } from '../../core/eventos.service';

const SMALL_WIDTH_BREAKPOINT = 1100;

@Component({
  selector: 'app-publicaciones',
  templateUrl: './publicaciones.component.html',
  styleUrls: ['./publicaciones.component.css']
})
export class PublicacionesComponent implements OnInit {
  
  eventos: any;
  //MAPA
  lat: number = -23.702451;
  lng: number = -70.421126;
  zoom: number = 16;

  //COMENTARIOS
  comentarios$: Observable<any[]>;
  numero$: any;

  comentarios: any;
  datos: any;

  ordenamientos = [
    { value: 'fecha', nombre: 'Fecha de Publicación' },
    { value: 'titulo', nombre: 'Titulo' },

  ];

  icono;

  titulo;

  cargando;

  categorias = CATEGORIAS;

  filtroCategoria$: BehaviorSubject<string | null>;
  filtroTituloInicio$: BehaviorSubject<string | null>;
  filtroTituloFin$: BehaviorSubject<string | null>;

  publicaciones$: Observable<any[]>;

  @ViewChild('sidenav') sidenav: MatSidenav;

  private twitter: any;

  formulario: FormGroup;

  mensajesValidacion = {
    // 'categoria': {
    //   'required': 'La categoría es obligatoria,',
    // },
    // 'titulo': {
    //   'required': 'El titulo es obligatorio.',
    //   'minlength': 'El título debe tener más de 5 caractéres',
    //   'maxlength': 'El título debe tener menos de 50 caracteres.',
    // },
    'texto': {
      'required': 'La descripcion es obligatoria.',
      'minlength': 'La descripcion debe tener más de 5 caractéres',
      'maxlength': 'La descripcion debe tener menos de 300 caracteres.',
    },
    // 'precio': {
    //   'required': 'El valor es obligatorio.',
    //   'maxlength': 'El valor debe tener menos de 7 cifras.',
    //   'pattern': 'El valor debe ser un número entero positivo.',
    // }
  }

  dialogResult;
  constructor(private es: EventosService, public fb: FormBuilder, private _router: Router, private comentariosService: ComentariosService, public publicacionService: PublicacionService, private renderer2: Renderer2, public afs: AngularFirestore, public dialog: MatDialog, public authService: AuthService) {
    this.initTwitterWidget();

    // this.publicaciones = this.afs.collection('publicaciones')
    // .map((proyectos) => {
    //   return proyectos.map((proyecto) => {
    //     proyecto.fotos = this.af.database.list(`/fotosejecucion/${proyecto.$key}`)
    //     return proyecto;
    //   })
    // });

  }

  ngOnInit() {
  this.eventos = this.es.getEventosFechaLimit();

    this.numero$ = 4;
    this.cargando = true;
    this.filtroCategoria$ = new BehaviorSubject(null);
    this.filtroTituloInicio$ = new BehaviorSubject(null);
    this.filtroTituloFin$ = new BehaviorSubject(null);

    this.publicaciones$ = Observable.combineLatest(
      this.filtroCategoria$,
      this.filtroTituloInicio$,
      this.filtroTituloFin$

    ).switchMap(([categoria, tituloinicio, titulofin]) =>
      this.afs.collection('publicaciones', ref => {
        // let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
        let query: any = ref;
        // query = query.orderBy('fecha', 'desc');
        if (categoria) { query = query.where('categoria', '==', categoria) };
        if (tituloinicio && titulofin) { query = query.orderBy('titulo').startAt(tituloinicio).endAt(titulofin) };
        return query;
      }).snapshotChanges().map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );
    this.titulo = "Todas las Publicaciones";
    this.icono = "public";

    setTimeout(() => {
      this.cargando = false
    }, 1000);

    //COMENTARIOS

    this.dialogResult = "";
    // this.filtroFecha$.next('fecha');

    this.formulario = this.fb.group({
      // 'categoria': ['', [Validators.required]],
      // 'titulo': [ '', [Validators.required,Validators.minLength(5),Validators.maxLength(50)]],
      'texto': ['', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]],
      // 'precio': ['', [Validators.required,Validators.pattern('^[1-9]+[0-9]*$'), Validators.maxLength(7)]],
      // 'fono': [{value: '', disabled: true}],
      // 'movil': [{value: '', disabled: true}],
      // 'email': [{value: '', disabled: true}],
    });

    // Get the packages
    // this.packageService.getPackages().subscribe(packages => {
    //   this.packages = packages;
    // });

    // this.comentarios$.subscribe(coms => {
    //   this.comentarios$ = this.comentariosService.getComments(this.numero$);
    // });


    // this.comentarios$ = this.comentariosService.getComments(this.numero$);

    // this.comentariosService.getComments(this.numero$).subscribe(comentarios => {
    //   this.comentarios$ = comentarios;
    // });


    // this.comentariosService.getComnum().subscribe(comentarios => {
    //   this.comentarios$ = comentarios;
    // });

    // this.comentarios$ = this.comentariosService.getComnum();
    // this.getComentarios();
  }

  initTwitterWidget() {
    this.twitter = this._router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        (<any>window).twttr = (function (d, s, id) {
          let js: any, fjs = d.getElementsByTagName(s)[0],
            t = (<any>window).twttr || {};
          if (d.getElementById(id)) return t;
          js = d.createElement(s);
          js.id = id;
          js.src = "https://platform.twitter.com/widgets.js";
          fjs.parentNode.insertBefore(js, fjs);

          t._e = [];
          t.ready = function (f: any) {
            t._e.push(f);
          };

          return t;
        }(document, "script", "twitter-wjs"));

        if ((<any>window).twttr.ready())
          (<any>window).twttr.widgets.load();

      }
    });
  }

  cargarComentarios(publicacionId: string) {
    this.numero$ += 5;
    // console.log(this.numero$)
    this.comentarios$ = this.comentariosService.getComments(this.numero$, publicacionId);
  }

  ngOnDestroy() {
    this.twitter.unsubscribe();
  }

  // checkComentarios(publicacionId: string) {
  //   console.log(publicacionId);
  //   this.comentarios$ = this.comentariosService.getComentarios(publicacionId);
  // }

  // getComentarios(publicacionId: string):boolean{
  //   this.comentarios$ = this.comentariosService.getComentarios(publicacionId);
  //   if(this.comentarios$){
  //     return true;
  //   }else{
  //     return false;
  //   }
  // }

  comms(comentarios) {
    return comentarios.slice(0,2);
  }

  getComentarios() : any {
    return this.comentariosService.getComnum();
  }

  getComentarioSub() : any {
    return this.comentariosService.getComnum();
  }

  mostrarComentarios(id: string) {
    this.comentarios = id;
  }
  mostrarDatos(id: string) {
    this.datos = id;
  }

  meGusta(id: string, valor: number) {
    this.publicacionService.actualizarPublicacion(id, { megusta: valor + 1 })
  }

  mouseenter(event) {
    this.renderer2.addClass(event.target, 'mat-elevation-z8')
  }

  mouseleave(event) {
    this.renderer2.removeClass(event.target, 'mat-elevation-z8')
  }

  openDialog(publicacion) {
    let dialogRef = this.dialog.open(MostrarComponent, {
      // width: '650px',
      data: publicacion,
      panelClass: 'my-full-screen-dialog',

    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog closed: ${result}`);
      this.dialogResult = result;
    });
  }

  isScreenSmall(): boolean {
    return window.matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`).matches;
  }

  filtroCategoria($event) {
    if ($event.target.value == '') {
      this.titulo = "Todas las Publicaciones";
      this.icono = "public"
    } else {
      this.titulo = "Publicaciones de: " + $event.target.value;
      for (var i = 0; i < this.categorias.length; i++) {
        if (this.categorias[i].nombre == $event.target.value) {
          this.icono = this.categorias[i].icono;
        }
      }
    }
    this.filtroCategoria$.next($event.target.value);
  }
  filtroTitulo($event) {
    const textoBuscar = $event.target.value
    this.filtroTituloInicio$.next(textoBuscar);
    this.filtroTituloFin$.next(textoBuscar + '\uf8ff');
  }

  filtroOrdenamiento($event) {
    // console.log($event.target.value);

    // if($event.target.value=='fecha'){
    //   this.ordenardesc$.next('fecha');
    // }
    // if($event.target.value=='titulo'){
    //   this.ordenardesc$.next('titulo');
    // }

    // if($event.target.value=='tituloas'){
    //   this.ordenarasc$.next('titulo');
    // }
    // if($event.target.value=='titulodes'){
    //   this.ordenardesc$.next('titulo');
    // }
    // if($event.target.value=='fechaas'){
    //   this.ordenarasc$.next('fecha');
    // }
    // if($event.target.value=='fechades'){
    //   this.ordenardesc$.next('fecha');
    // }
  }

  get texto() { return this.formulario.get('texto') }

  comentar(user: User, publicacionId: string) {

    // for(var i=0;i<this.categorias.length;i++){
    //   if(this.categorias[i].nombre==this.categoria.value){
    //     this.iconoCat = this.categorias[i].icono;
    //   }
    // }

    var texto_con_espacio = this.texto.value.replace(new RegExp('\n', 'g'), "<br>");

    this.comentariosService.agregarComentario(user, publicacionId, texto_con_espacio);
    this.formulario.reset();

  }


}



// WEBPACK FOOTER //
// ./src/app/publicaciones/publicaciones/publicaciones.component.ts